import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { HeaderContent } from '@backrs_ui/common-ui/src/atoms/HeaderContent';
import { Box, Typography } from '@mui/material';
export var Header = function (_a) {
    var title = _a.title, secondaryTitle = _a.secondaryTitle, titleIcon = _a.titleIcon, middleSection = _a.middleSection, rightSection = _a.rightSection;
    return (_jsx(HeaderContent, { children: _jsxs(Box, { sx: containerStyle, children: [_jsxs(Box, { sx: leftMiddleContainerStyle, children: [_jsxs(Box, { sx: leftSectionStyle, children: [titleIcon && _jsx("img", { src: titleIcon, style: logoStyle, alt: title }), _jsxs(Box, { sx: titleContainerStyle, children: [_jsx(Typography, { sx: titleStyle, children: title }), secondaryTitle && _jsx(Typography, { sx: secondaryTitleStyle, children: secondaryTitle })] })] }), middleSection && _jsx(Box, { sx: middleSectionStyle, children: middleSection })] }), rightSection && _jsx(Box, { sx: rightSectionStyle, children: rightSection })] }) }));
};
var containerStyle = {
    width: '100%',
    padding: '10px 10px 0px 30px',
    borderRadius: '0px 0px 8px 8px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 'auto',
    '@media (max-width: 900px)': {
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    '@media (max-width: 600px)': {
        padding: '5px 5px 5px 10px',
    },
};
var leftMiddleContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '45%',
    overflow: 'hidden',
    gap: '10px',
    '@media (max-width: 900px)': {
        width: '100%',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
};
var titleContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
    alignItems: 'center',
};
var titleStyle = {
    fontSize: '24px',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    color: appColors.color.blue1,
};
var secondaryTitleStyle = {
    fontSize: '24px',
    color: appColors.color.blue1,
    whiteSpace: 'nowrap',
    fontWeight: '200',
};
var logoStyle = {
    width: '40px',
    height: '40px',
};
var leftSectionStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '10px',
    '@media (max-width: 900px)': {
        flexDirection: 'column',
    },
};
var middleSectionStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '10px',
    '@media (max-width: 900px)': {
        flexDirection: 'column',
    },
};
var rightSectionStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '55%',
    gap: '10px',
    '@media (max-width: 900px)': {
        width: '100%',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
};
